// extracted by mini-css-extract-plugin
export default {"loader":"HomeSearchBar_loader__aNX8D","spin":"HomeSearchBar_spin__AbFv5"};